<template>
    <div class="main-wrapper d-flex justify-center section_wrapper" style=" line-height: 1.7em; max-width: 1150px; margin:auto">
    <div class="entry-content clear left-text" itemprop="text">

		
		
        <h2 id="p-cookies"><strong>Política de Cookies</strong></h2>
        
        
        
        <p>En la web de HELLOTECA utilizamos cookies para facilitar la relación de los visitantes con nuestro contenido. En cumplimiento de la Directiva 2009/136/CE, desarrollada en la Ley de Servicios de Sociedad de la Información en su artículo 22.2 y siguiendo las directrices de la Agencia Española de Protección de Datos procedemos a informarle del uso de las cookies que se realiza en nuestra web.</p>
        
        
        
        <p>Se denominan cookies a unos ficheros que se guardan en el navegador utilizado por cada visitante de nuestra web para que el servidor pueda recordar la visita de ese usuario con posterioridad cuando vuelva a acceder a nuestros contenidos. Esta información no revela su identidad, ni dato personal alguno, ni accede al contenido almacenado en su ordenador personal, pero sí que permite a nuestro sistema identificarle a usted como un usuario determinado que ya visitó la web con anterioridad, visualizó determinadas páginas, etc. y además permite guardar sus preferencias personales e información técnica como las visitas realizadas o páginas concretas que visite.</p>
        
        
        
        <p>Existen cookies propias y cookies de terceros. Para su comprensión, es necesario que conozcas las siguientes definiciones:</p>
        
        
        
        <p>Cookies de terceros: Son gestionadas por otras empresas e instaladas desde sus equipos y/o dominios al equipo terminal aunque se utilicen por la titular de esta página web.</p>
        
        
        
        <p>Cookies Propias: Son gestionadas por la titular de esta página web e instaladas desde los ordenadores de la misma al equipo terminal del usuario.</p>
        
        
        

       <h2 id="p-cookies"><strong>Listado de cookies y consentimiento</strong></h2>
       <div ref="cookies"></div>
        
       
        
    </div>
</div>
</template>

<script>
    const api = 'https://api7.cloudframework.io/helloteca/score';
    import axios from 'axios';
    
    import { mapState, mapMutations, mapActions } from 'vuex';
    import rulesMixin from '../mixins/rulesMixin';
    import goTo from 'vuetify/es5/services/goto'

    export default {
        mixins: [rulesMixin],
        components:{
            
        },
        data() {
            return {
                valid: false,
                show: false,
                animationFade: 'fadeR' 
            }
        },
        mounted() {
        
             
            let foo = document.createElement('script');    
            foo.setAttribute("src","https://consent.cookiebot.com/0d222865-114c-462d-882f-6b146682c8cf/cd.js");
            foo.setAttribute("type", "text/javascript");
            foo.setAttribute("async",true);
             foo.setAttribute("id","CookieDeclaration");
            this.$refs.cookies.appendChild(foo);
            
        },
        methods: {
            ...mapMutations([
                'CHANGE_ACTIVE_PRODUCT',
                'SET_ACTIVE_STEP',
                'ADD_OWNER',
                'DELETE_OWNER',
                'SET_OWNER_BIRTHDATE',
                'SET_OWNER_JOB_SENIORITY',
                'SET_PRESCORING_DATA',
                'SET_LOADING'
            ]),
            ...mapActions([
                'calculateScoring',
            ]),
        },
        computed: {
            ...mapState([
                'initalDataLoaded',
                'commonVars',
                'loading',
                'offerType',
                'years',
                'owners',
                'products',
                'preScoring',
                'token_id',
                'accesibleViews'
            ]),
            productTitle(){
                if(this.preScoring && this.preScoring.Vivienda && this.preScoring.Vivienda.tipo_vivienda){
                    let index = this.products.map(product => product.type).indexOf(this.preScoring.Vivienda.tipo_vivienda);
                    return (index >= 0) ? this.products[index].title : '';
                }else{
                    return '';
                }
            },
            
            
        },

    }
</script>

<style lang="scss" scoped>
    .main-wrapper{
        padding: 20px;
        box-sizing: border-box;
    }
    .section_wrapper{
        max-width: 1150px;
        .left-text{
            h2{
                font-weight: 500;
                font-size: 1.6rem;
                line-height: 1.9rem;
                margin-bottom: 20px;
            }
            p{
                font-weight: 500;
                font-size: 20px;
                line-height: 1.6rem;
                span{
                    color: var(--helloteca-main);
                    font-weight: bold;
                }
            }
        }
    }
    .CookieDeclaration p {
        font-size: 20;
    }
    .form_wrapper{
        h2{
            font-weight: bold;
            color: var(--helloteca-main);
            font-size: 1.7rem;
            line-height: 1.5rem;
        }
    }
    .steps_info{
        font-size: 0.8rem;
        line-height: .9rem;
        color: #999;
        margin-top: 10px;
    }
    .add-owner-btn{
        text-transform: initial;
        letter-spacing: initial;
        border-radius: 6px;
        font-weight: bold;
        background: #FFF !important;
        color: var(--helloteca-main);
        border: 1px solid var(--helloteca-main) !important;
        transition: all .3s !important;
        &.remove{
            color: #CC0000;
            border: 1px solid #CC0000 !important;
            &:hover{
                transition: all .3s !important;
                background: #CC0000 !important;
                color: #FFF !important;
            }
        }
        &:hover{
            transition: all .3s !important;
            background: var(--helloteca-main) !important;
            color: #FFF !important;
        }
    }
</style>